import React from "react";

import "./style.css";
import { Col, Row } from "react-bootstrap";

export const CompanyIconText = ({
  className,
  icon, //= <CompanyIcon1 className="podjetje-icon" />,
}) => {
  return (
    <Row className="d-inline-flex g-5">
      <Col xs={3} md={3} lg={3}>
        {icon}
      </Col>
      <Col xs={8} md={9} lg={9} className="d-flex align-items-center">
        <div className="podjetje-text">PODJETJE</div>
      </Col>
    </Row>
  );
};
